<ng-select 
    [items]="tiposMateriasPedidos" 
    [loading]="load"
    [multiple]="selecionaMultiplos"
    [(ngModel)]="tipoMateriaPedidoId" 
    [ngModelOptions]="{standalone: true}"
    bindLabel="nome" 
    bindValue="id" 
    placeholder="Digite o tipo da matéria do pedido" 
    notFoundText="Não há dados para esse filtro"
    loadingText="Buscando"
    clearAllText="Limpar seleção"
    (keyup)="filtrar($event)"
    (click)="changeTipoMateriaPedido($event)"
    (clear)="limpar()"
    >
</ng-select>
